import React from "react"
import SemrushBannerCardField from "./SemrushBannerCardField"
import { useListContext } from "react-admin"
import { Grid } from "@mui/material"

const SemrushBannerGrid = () => {
    const { data, isLoading } = useListContext()

    if (isLoading) {
        return <></>
    }

    return (
        <Grid container spacing={1}>
            {data.map(record => (
                <Grid item key={record.id}>
                    <SemrushBannerCardField key={record.id} record={record} />
                </Grid>
            ))}
        </Grid>
    )
}

export default SemrushBannerGrid
